// SIMPLE FIX: Prevent OpenAI initialization issue
if (typeof window === 'undefined' && !process.env.OPENAI_API_KEY) {
  // Set to empty string specifically (not dummy value) - this prevents OpenAI initialization
  process.env.OPENAI_API_KEY = '';
}

import { createClient } from '@supabase/supabase-js';

// Check if Supabase environment variables are available
if (!import.meta.env.VITE_SUPABASE_URL || !import.meta.env.VITE_SUPABASE_KEY) {
  console.error('❌ [SUPABASE] Supabase environment variables are missing');
  console.error('❌ [SUPABASE] VITE_SUPABASE_URL:', import.meta.env.VITE_SUPABASE_URL ? 'Set' : 'Missing');
  console.error('❌ [SUPABASE] VITE_SUPABASE_KEY:', import.meta.env.VITE_SUPABASE_KEY ? 'Set' : 'Missing');
  console.warn('⚠️ [SUPABASE] Using fallback configuration - some features may not work');
}

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_KEY;

export const supabase = createClient(supabaseUrl, supabaseKey, {
  // SIMPLE FIX: Disable AI features to prevent OpenAI dependencies
  global: {
    headers: {
      'X-Client-Info': 'lightreads-web'
    }
  }
}); 